<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<!-- Cards container -->
<div class="reviews-container">
  @for (review of reviews; track review) {
    <div class="col-lg-4 col-md-6 review-card">
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">Recenzija prijave</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <!-- Overall details -->
          <p><strong>Ocijenio korisnik:</strong> {{ review.evaluatorUsername || 'Anonimni recenzent' }}</p>
          <p><strong>Datum ocjene:</strong> {{ review.reviewDate | date: 'd.M.yyyy. HH:mm:ss' }}</p>
          <p><strong>Ukupni bodovi:</strong> {{ review.totalScore }} / 50</p>
          <p>
            <strong>Ocjena:</strong>
            <span class="daxa-badge" [ngClass]="{ 'positive': review.totalScore >= 30, 'negative': review.totalScore < 30 }">
              {{ review.totalScore >= 30 ? 'Pozitivna' : 'Negativna' }}
            </span>
          </p>
          <p><strong>Opisna ocjena projekta/programa:</strong></p>
          <p>{{ review.comments }}</p>
          <div class="mb-25">
            <p><strong>1. Provedba programa/projekta/manifestacije će dovesti do zadovoljenja ciljeva iz strateških i razvojnih dokumenata odnosno natječaja</strong></p>
            <p>Ocjena: {{ review.strategicGoalAchievementScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>2. Prijavitelj je jasno razradio aktivnosti programa/projekta/manifestacije, aktivnosti su u skladu s ciljevima i očekivanim rezultatima, jasne, opravdane i provedive</strong></p>
            <p>Ocjena: {{ review.activityClarityAndFeasibilityScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>3. Aktivnosti su usmjerene na zadovoljenje potreba, u većoj mjeri građana općine Donji Andrijevci</strong></p>
            <p>Ocjena: {{ review.localNeedsAlignmentScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>4. Aktivnosti doprinose razvoju kulturnog/sportskog/društvenog života stanovnika općine Donji Andrijevci</strong></p>
            <p>Ocjena: {{ review.communityLifeEnhancementScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>5. Jasno su definirani i strateški odabrani sudionici (krajnji korisnici, ciljne skupine)</strong></p>
            <p>Ocjena: {{ review.participantDefinitionScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>6. Podnositelj (i partneri, ako je primjenjivo) imaju dovoljno iskustva u upravljanju programima i projektima/organizaciji manifestacija, dovoljnu tehničku stručnost i upraviteljsku sposobnost</strong></p>
            <p>Ocjena: {{ review.managementAndExpertiseScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>7. Troškovi u financijskom planu programa/projekta/manifestacije realno su iskazani</strong></p>
            <p>Ocjena: {{ review.costRealismScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>8. Stavke proračuna povezane su s prijavljenim aktivnostima</strong></p>
            <p>Ocjena: {{ review.budgetItemLinkageScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>9. Šira zajednica/volonteri će biti uključeni u provedbu aktivnosti</strong></p>
            <p>Ocjena: {{ review.communityInvolvementScore }} / 5</p>
          </div>
          <div class="mb-25">
            <p><strong>10. U prijavi je jasno prikazan način obavještavanja javnosti o programu/projektu/manifestaciji, osigurana je promocija aktivnosti i Općine te medijska pokrivenost</strong></p>
            <p>Ocjena: {{ review.publicCommunicationAndPromotionScore }} / 5</p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>